import { useEffect, useState } from "react";
import { publicGet } from "@/lib/publicApi";
import { MessageCircle } from "lucide-react";

/** Marketing WhatsApp CTA — click-to-chat to the WABA number stored on
 *  the Comms Center. Number is fetched at runtime so a Super Admin swap
 *  updates every placement without a redeploy. Fire-and-forget click
 *  beacon feeds the existing web_events pipeline.
 */
export default function WhatsAppCta({ variant = "footer", className = "", label, prefill }) {
    const [info, setInfo] = useState(null);
    useEffect(() => {
        const q = prefill ? `?text=${encodeURIComponent(prefill)}` : "";
        publicGet(`/wa-cta${q}`).then(setInfo).catch(() => setInfo({ enabled: false }));
    }, [prefill]);

    if (!info?.enabled) return null;

    const track = () => {
        try {
            const beacon = new Blob([JSON.stringify({
                cta: "whatsapp_marketing", variant, url: info.wa_me_url,
                path: window.location.pathname,
            })], { type: "application/json" });
            navigator.sendBeacon?.(
                `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "")}/api/public/track/cta`,
                beacon,
            );
        } catch (e) { /* swallow — CTA click must not depend on tracking */ }
    };

    const baseCls = variant === "footer"
        ? "inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors text-[13px]"
        : variant === "inline"
        ? "inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE57] text-white font-semibold px-4 py-2 text-sm shadow-sm transition-colors"
        : "inline-flex items-center gap-2 rounded-lg border border-[#25D366] text-[#25D366] hover:bg-[#25D366] hover:text-white font-semibold px-4 py-2 text-sm transition-colors";

    return (
        <a
            href={info.wa_me_url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={track}
            className={`${baseCls} ${className}`}
            data-testid={`wa-cta-${variant}`}
        >
            <MessageCircle size={variant === "footer" ? 14 : 16} />
            <span>{label || "Message us on WhatsApp"}</span>
        </a>
    );
}
